<template>
    <header
        class="header_style3 nav-stacked affix-top"
        data-spy="affix"
        data-offset-top="1"
    >
        <!-- Navigation -->
        <nav id="navigation_bar" class="navbar navbar-expand-lg">
            <div class="container">
                <div class="row header-row">
                    <div class="navbar-header">
                        <div class="logo">
                            <a href="/"
                                ><img
                                    src="/assets/images/logo/logo_dark2.png"
                                    alt="Logo-Redautos"
                            /></a>
                        </div>
                        <button
                            id="menu_slide"
                            data-target="#navigation"
                            aria-expanded="false"
                            data-toggle="collapse"
                            class="navbar-toggler"
                            type="button"
                        >
                            <i class="fa fa-bars"></i>
                        </button>
                    </div>
                    <div class="collapse navbar-collapse" id="navigation">
                        <div class="quick-support">
                            <p>
                                <a href="mailto:servicioalcliente@redautos.com">
                                    <i
                                        class="fa fa-envelope-o"
                                        aria-hidden="true"
                                    ></i>
                                    servicioalcliente@redautos.com</a
                                >
                            </p>
                            |
                            <p>
                                <a href="https://wa.link/axe8kp" target="blank"
                                    ><i
                                        class="fa fa-whatsapp"
                                        aria-hidden="true"
                                    ></i>
                                    318 8274142</a
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <!-- Navigation end -->
    </header>
</template>

<script>
import config from "config/config.json";
export default {
    data() {
        return {
            logo:
                "https://brokcars-assets.s3.us-east-2.amazonaws.com" +
                config.logo_url
        };
    }
};
</script>

<style lang="scss">
.quick-support {
    background: #000000 !important;
}
.quick-support::after {
    border-color: #000000 transparent transparent !important;
}
</style>
